import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d871da2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-16 text-default font-500" }
const _hoisted_2 = { class: "text-gray mt-5 text-14 leading-20" }
const _hoisted_3 = { class: "text-gray mt-5 text-14 leading-20" }
const _hoisted_4 = { class: "text-gray mt-5 text-14 leading-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_checkbox = _resolveComponent("van-checkbox")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative", _ctx.classes]),
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onToggle && _ctx.onToggle(...args)))
  }, [
    _createElementVNode("h3", _hoisted_1, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.userName) + _toDisplayString(_ctx.userName ? "的" : "") + _toDisplayString(_ctx.title), 1)
      ], true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" 审批编号： "),
      _renderSlot(_ctx.$slots, "code", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.code), 1)
      ], true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "content", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.content), 1)
      ], true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "footer", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.footer), 1)
      ], true),
      (_ctx.selectable)
        ? (_openBlock(), _createBlock(_component_van_checkbox, {
            key: 0,
            style: {"float":"right"},
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.statusClass(), "list-item-status"])
    }, _toDisplayString(_ctx.typeName), 3)
  ], 2))
}